import { render, staticRenderFns } from "./ApprovalTradeHistory.vue?vue&type=template&id=7cfb7b73"
import script from "./ApprovalTradeHistory.vue?vue&type=script&lang=js"
export * from "./ApprovalTradeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cfb7b73')) {
      api.createRecord('7cfb7b73', component.options)
    } else {
      api.reload('7cfb7b73', component.options)
    }
    module.hot.accept("./ApprovalTradeHistory.vue?vue&type=template&id=7cfb7b73", function () {
      api.rerender('7cfb7b73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/admin/ApprovalTradeHistory.vue"
export default component.exports